/**
 * EA's transfer-market tax, for DISPLAY in the employee panel only.
 *
 * The number that actually matters — what is sent to FutTransfer and what the
 * customer is told — is computed by the worker (worker/lib/eaMath.js) and comes
 * back on the API. This mirror only lets the form say "customer receives X"
 * while someone is still typing. Keep the two rates and the rounding identical.
 */
export const EA_TAX_PCT = 5;

/** K coins that land in the customer's club for a purchase of `grossK`. */
export const netCoinsK = (grossK: number): number => {
  if (!Number.isFinite(grossK) || grossK <= 0) return 0;
  return Math.floor(grossK * ((100 - EA_TAX_PCT) / 100) + 1e-9);
};
